import React, { useState, useEffect, useRef } from "react";
import { get } from '../../Services/http';
import CasallProPurchaseMultiSizeInputComponent from '../../Containers/CasallPro/CasallProPurchaseMultiSizeInput.container'
import { translate } from '../../Services/translation';
import BuyButton from '../../Containers/BuyButton.Container';
import { pushToDatalayer } from "../../wooscripts/gtmEnchanced";
import { connect } from 'react-redux';
import { updateData, setDefaultData } from '../../Actions/PurchaseMultiSizeInput.action'

 
const CasallProQuickBuyPopup = props => {

    const [activeVariant, setActiveVariant] = useState()
    const [activeVariantId, setActiveVariantId] = useState(props.productAvailableColors[0].VariantId)
    const [buyButtonCssClass, setBuyButtonCssClass] = useState()
    const [buttonLabel, setButtonLabel] = useState()
  
    const wrapperRef = useRef(null)
  
    /**
   * Hook that closes element if clicked ouside of the passed ref
   */
   function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * If clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props.handleClose();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  
    useEffect(() => {
      get(`/api/quickbuy/activevariant?variantid=${activeVariantId}`)
          .then(response => response.json())
          .then(result => {
              setActiveVariant(result)
            })
        }, [activeVariantId])
  
    useEffect(() => {
      if (activeVariant) {
        props.updateData(JSON.parse(activeVariant.sizeInputComponentData))
        props.setDefaultData(JSON.parse(activeVariant.sizeInputComponentData))
        let cssClass = "button buy-button product-detail__buy-button";
        setButtonLabel(translate('product.buy'))
  
        if (activeVariant.loggedOutHref)
          setButtonLabel(activeVariant.loggedOutText)
  
        // if (activeVariant.anySizeOfColorInStock === false && !activeVariant.loggedOutHref) {
        //   cssClass += " disabled"
        //   setButtonLabel(translate('stock.outofstockwithoutquantity'))
        // }
  
        setBuyButtonCssClass(cssClass)
      }
    }, [activeVariant])
  
    useOutsideAlerter(wrapperRef);


  return (
    <div className="boxWrapper">
      <div className="box" ref={wrapperRef}>
        <div className="product-detail__quickbuy-text">{activeVariant && activeVariant.productName}</div>
        <img className="close-icon" src="/ui/images/close_black.svg" onClick={props.handleClose} alt="Close icon"/>
        {translate('pro.quickbuy.title')}
        <div className="available-colors">
          {activeVariant && 
            <CasallProPurchaseMultiSizeInputComponent 
            sizeinputfields={activeVariant.sizeInputComponentData}
            loggedouttext={activeVariant.loggedOutText}
            offert={activeVariant.offert}
            producttype={props.producttype}
            productid={props.productid}/>
          }
        </div>

        <div className="product-detail__quickbuy-text">
            { activeVariant && activeVariant.loggedOutText ?
            activeVariant.loggedOutText
              : ( activeVariant && activeVariant.offert
                  ? translate('product.quotation')
                  : null
              )
          }
        </div>

        {(activeVariant && activeVariant.loggedOutText === null && !activeVariant.offert) &&
          translate('product.master.ex.vat')
        }

        {activeVariant && buttonLabel && (
          <>
              {buyButtonCssClass === "button buy-button product-detail__buy-button" && 
              <gtm-tag onClick={() => pushToDatalayer({...props.gtmTrackingData})}>
                <BuyButton cssClass={buyButtonCssClass} label={translate('product.buy')} ></BuyButton> 
              </gtm-tag>
               }
            {buyButtonCssClass !== "button buy-button product-detail__buy-button" 
              && <BuyButton cssClass={buyButtonCssClass} label={translate('stock.outofstockwithoutquantity')} ></BuyButton>}
          </>)
        }
      </div>
      </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
      updateData: (data) => dispatch(updateData(data)),
      setDefaultData: (data) => dispatch(setDefaultData(data))
  }
}


export default connect(null, mapDispatchToProps)(CasallProQuickBuyPopup)
